
import { Box, IconButton, Typography } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import useStyles from '../GlobalStyles/AccountDetailCss';
// Icons
import Snackbar from '@material-ui/core/Snackbar';
import SettingsBackupRestoreTwoToneIcon from '@material-ui/icons/SettingsBackupRestoreTwoTone';
// Models
import { IPlacedAccount } from '../../models/Inquiry/IPlacedAccount';
import { useGlobalState } from '../../store/GlobalStore';
import { useFetch, usePost } from '../../utils/apiHelper';
import { IInsertTransactionLog } from '../../models/UpdateHistory/GetTransactionOptions';
import { InsertTransactionLog } from '../TransactionLogs/InsertTransactionLog';

const Submit: React.FC<{ clientId: string, dbtNo: string, onSubmit: () => void, placedAccounts: IPlacedAccount[], BlockAwaitAccess: boolean }> = (props) => {
    const classes = useStyles();
    const { state } = useGlobalState();
    const [undoSubmit, setundoSubmit] = React.useState(false);

    const undoAdjustment = (adjustmentAmount: number, adjustmentType: string, reversedHistoryId: number) => {
        (async () => {
            let request = {
                "Dbt_No": props.dbtNo,
                "AdjustmentAmount": adjustmentAmount,
                "AdjustmentType": adjustmentType
            }

            let feedOperation = [];
            let operations: IInsertTransactionLog = {
                operationName: "Undo Payment", operationText: 'Payment Undone'
            };
            feedOperation.push(operations);

            await usePost<any>("Account/UndoAdjustment", request);
            await useFetch<any>("Account/UndoPaymentAmount");
            InsertTransactionLog(state?.userAccessContext?.id, props?.dbtNo, feedOperation, false, reversedHistoryId);
            props.onSubmit();
            setundoSubmit(false);
        })()
    }

    function Alert(props: AlertProps) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const closeSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setundoSubmit(false);
    };

    if (props.placedAccounts.find(x => x.prpcl_Pay_Amt > 0 || x.prcpl_Adj_Amt != 0 || x.fee_Pay_Amt > 0 || x.fee_Adj_Amt != 0)) {
        return (
            <Box className={classes.rootSubmit} margin={2} >
                <Scrollbars autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={10}
                    autoHeight
                    autoHeightMin={80}
                    autoHeightMax={80}
                    style={{ width: "100%" }}>
                    <div className={classes.submitDiv}>
                        <Typography variant="overline" display="block" className={classes.textSpan}>
                            Pending...
                        </Typography>
                        {props.placedAccounts.reverse().map(p => {
                            return (
                                <span className={classes.textSpan2}>
                                    {Math.abs(p?.prpcl_Pay_Amt) > 0 ? <div >Principal Payment: {p?.prpcl_Pay_Amt.toFixed(2)} <IconButton disabled={props?.BlockAwaitAccess} id="R_Undo_PrincipalPayment" onClick={() => { setundoSubmit(true); undoAdjustment(p?.prpcl_Pay_Amt, "Principal Payment", p?.historyId); }}><SettingsBackupRestoreTwoToneIcon /></IconButton></div> : null}
                                    {Math.abs(p?.prcpl_Adj_Amt) > 0 ? <div>Principal Adjustment: {p?.prcpl_Adj_Amt.toFixed(2)}<IconButton disabled={props?.BlockAwaitAccess} id="R_Undo_PrincipalAdjustment" onClick={() => { setundoSubmit(true); undoAdjustment(p?.prcpl_Adj_Amt, "Principal Adjustment", p?.historyId); }}><SettingsBackupRestoreTwoToneIcon /></IconButton></div> : null}
                                    {Math.abs(p?.fee_Pay_Amt) > 0 ? <div>Late Fee Payment: {p?.fee_Pay_Amt.toFixed(2)}<IconButton disabled={props?.BlockAwaitAccess} id="R_Undo_FeePayment" onClick={() => { setundoSubmit(true); undoAdjustment(p?.fee_Pay_Amt, "Fee Payment", p?.historyId); }}><SettingsBackupRestoreTwoToneIcon /></IconButton></div> : null}
                                    {Math.abs(p?.fee_Adj_Amt) > 0 ? <div>Late Fee Adjustment: {p?.fee_Adj_Amt.toFixed(2)}<IconButton disabled={props?.BlockAwaitAccess} id="R_Undo_FeeAdjustment" onClick={() => { setundoSubmit(true); undoAdjustment(p?.fee_Adj_Amt, "Fee Adjustment", p?.historyId); }}><SettingsBackupRestoreTwoToneIcon /></IconButton></div> : null}
                                </span>
                            );
                        })}
                    </div>
                </Scrollbars>
                <Snackbar className="snackBarStyle" open={undoSubmit} anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }} autoHideDuration={4000} onClose={closeSnackbar}>
                    <Alert onClose={closeSnackbar} severity="error" className="alertStyle">
                        Undo Transaction Successfully!
                    </Alert>
                </Snackbar>
            </Box>
        )
    }
    else {
        return (null);
    }
}

export default Submit